import { render, staticRenderFns } from "./businessDepartment.vue?vue&type=template&id=9e97ddde&scoped=true"
import script from "./businessDepartment.vue?vue&type=script&lang=js"
export * from "./businessDepartment.vue?vue&type=script&lang=js"
import style0 from "./businessDepartment.vue?vue&type=style&index=0&id=9e97ddde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e97ddde",
  null
  
)

export default component.exports